import { PredictionCardWrapper } from './PredictionCardWrapper/PredictionCardWrapper';

export const PredictionCardSkeleton = () => {
  return (
    <PredictionCardWrapper>
      <div className="p-4 pt-3 w-full h-full">
        <div className="h-full flex flex-col justify-between">
          <div className="h-full flex flex-col gap-6">
            <div className="flex justify-between">
              <div className="w-20 h-4 skeleton-text" />
              <div className="w-20 h-4 skeleton-text" />
            </div>
            <div className="h-full flex flex-col items-center justify-center mb-12">
              <div className="flex h-12 items-center mb-4">
                <div className="skeleton-block rounded-full h-8 w-20" />
              </div>
              <div className="flex flex-col gap-3 items-center">
                <div>
                  <div className="h-5 flex items-center justify-center">
                    <div className="w-20 h-4 skeleton-text" />
                  </div>
                  <div className="h-10 flex items-center">
                    <div className="w-40 h-9 skeleton-text" />
                  </div>
                </div>
                <div className="w-20 h-4 skeleton-text" />
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex gap-2">
              <div className="skeleton-block w-full h-16" />
              <div className="skeleton-block w-full h-16" />
            </div>
            <div className="skeleton-block w-full h-10" />
          </div>
        </div>
      </div>
    </PredictionCardWrapper>
  );
};
